import { createUserModalStyles } from "@insite/content-library/Widgets/UserList/CreateUserModal";

import { blackBlueBtn } from "@tKgpco/Extensions/Components/WishListCardExtension";
import { headerStyles } from "@tKgpco/Overrides/Widgets/AccountSettings/AccountSettingsHeader";
import { COLORS, TYPOGRAPHY } from "@tKgpco/theme/design";

Object.assign(createUserModalStyles, {
    submitButton: blackBlueBtn.actionAddToCartButton,
    cancelButton: blackBlueBtn.actionDeleteButton,
    settingsHeadingText: {
        size: 15,
        weight: TYPOGRAPHY.weight.bold,
    },
});
